export const REIMBURSEMENT_MAPPING = {
  states: {
    "British Columbia": 180.0,
    California: 330.0,
    Quebec: 160.0,
    "New York": 230.0,
    Massachusetts: 170.0,
    Alberta: 150.0,
    Indiana: 470.0,
    Texas: 330.0,
    Ohio: 380.0,
    Saskatchewan: 140.0,
    Illinois: 180.0,
    Connecticut: 400.0,
    Missouri: 440.0,
    Georgia: 420.0,
    Kentucky: 385.0,
    Florida: 310.0,
    Manitoba: 90.0,
    "Nova Scotia": 170.0,
    Vermont: 420.0,
    Nebraska: 410.0,
    "Rhode Island": 350.0,
    "Newfoundland and Labrador": 220.0,
    Washington: 420.0,
    Pennsylvania: 350.0,
    "New Jersey": 350.0,
    Virginia: 370.0,
    "North Carolina": 380.0,
    Arizona: 370.0,
    Tennessee: 210.0,
    Colorado: 440.0,
    Maryland: 250.0,
    Minnesota: 370.0,
    Wisconsin: 370.0,
    Oregon: 290.0,
    Nevada: 270.0,
  },
  countries: {
    Germany: 460.0,
    "Hong Kong": 910.0,
    India: 780.0,
    France: 390.0,
    Mexico: 350.0,
    England: 370.0,
    Spain: 390.0,
    Algeria: 590.0,
    Romania: 590.0,
    Ireland: 380.0,
    Ghana: 890.0,
    Azerbaijan: 1180.0,
    Mongolia: 1090.0,
    Netherlands: 390.0,
    Austria: 510.0,
    "Czech Republic": 510.0,
    China: 980.0,
    Switzerland: 480.0,
    "United Arab Emirates": 685.0,
  },
};

export const getReimbursementAmount = (location: string | undefined | null) => {
  if (!location) {
    return {
      amount: 0,
    };
  }
  const rsvpLocation = location.toLowerCase();
  const rsvpParsed = rsvpLocation.split(", ");
  if (rsvpParsed.length >= 2) {
    const stateParsed = rsvpParsed[1];
    for (const state of Object.keys(REIMBURSEMENT_MAPPING.states)) {
      if (stateParsed.includes(state.toLowerCase())) {
        const reimbursementAmount = REIMBURSEMENT_MAPPING.states[state];
        return {
          amount: reimbursementAmount,
        };
      }
    }
  }
  for (const country of Object.keys(REIMBURSEMENT_MAPPING.countries)) {
    if (rsvpLocation.includes(country.toLowerCase())) {
      const reimbursementAmount = REIMBURSEMENT_MAPPING.countries[country];
      return {
        amount: reimbursementAmount,
      };
    }
  }
  // if location not in mapping
  return { amount: -1 };
};
